import "intersection-observer";

export { useInView as default } from "react-intersection-observer";
